import { render, staticRenderFns } from "./devInfo.vue?vue&type=template&id=b652c702"
import script from "./devInfo.vue?vue&type=script&lang=js"
export * from "./devInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b652c702')) {
      api.createRecord('b652c702', component.options)
    } else {
      api.reload('b652c702', component.options)
    }
    module.hot.accept("./devInfo.vue?vue&type=template&id=b652c702", function () {
      api.rerender('b652c702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/floorPlan/devInfo.vue"
export default component.exports